import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EstimateCard from './EstimateCard';
import expandAll from '../../actions/uiState/expandAll';
import collapseAll from '../../actions/uiState/collapseAll';

const mapStateToProps = ({ estimateBuilder }, { selectedDesignId }) => {
  const { entities } = estimateBuilder;
  const design = get(`estimates.byId.${selectedDesignId}`, entities);

  return {
    design,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ expandAll, collapseAll }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EstimateCard);
